<div class="fx-fill fx-layout-col">
  <div class="sheet-header">
    <div class="fx-layout-row fx-justify-start fx-align-baseline">
      <div class="sheet-title fx-flex-85-percent">
        <span>{{ work?.toString() }}</span>
      </div>
      <div class="fx-flex-48">
        <div class="btn-container">
          <button (click)="closeWorkSidebar()" [disableRipple]="true"
                  class="fx-layout-col fx-justify-center fx-align-center"
                  id="close-sheet-button" mat-icon-button>
            <mat-icon fontSet="mdi" fontIcon="mdi-close" class="sm" aria-hidden="true"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="fx-layout-row">
      <restricted-icon-button
        (onClick)="uploadWorkDocuments()"
        icon="mdi-paperclip"
        iconClass="sm"
        [id]="'add-document-button'"
        [matTooltip]="'BUTTON.ADD_DOCUMENT' | translate"
        [permissions]="[Permission.EDIT_WORK, Permission.CREATE_DOCUMENT]">
      </restricted-icon-button>
      <restricted-icon-button
        (onClick)="uploadWorkPictures()"
        icon="mdi-image-plus"
        iconClass="sm"
        [id]="'add-picture-button'"
        [matTooltip]="'BUTTON.ADD_PICTURE' | translate"
        [permissions]="[Permission.EDIT_WORK, Permission.CREATE_DOCUMENT]">
      </restricted-icon-button>
      <restricted-icon-button
        (onClick)="deleteWork()"
        icon="mdi-delete"
        iconClass="sm"
        [id]="'delete-button'"
        [matTooltip]="'BUTTON.DELETE' | translate"
        [permissions]="[Permission.DELETE_WORK]">
      </restricted-icon-button>
      <restricted-icon-button
        (onClick)="duplicateWork()"
        icon="mdi-content-copy"
        iconClass="sm"
        [id]="'duplicate-button'"
        [matTooltip]="'BUTTON.DUPLICATE' | translate"
        [permissions]="[Permission.CREATE_WORK]">
      </restricted-icon-button>
      <workflow-buttons
        [entityType]="EntityType.WORK"
        [view]="ManualWorkflowViewEnum.SIDEPANEL"
        [selectedEntityIds]="[work?.id]">
      </workflow-buttons>
      <span class="fx-flex"></span>

      <div class="sheet-link">
        <span (click)="navigateToWorkSheet()">{{ 'BUTTON.SHOW_WORK_SHEET' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="sidebar-sheet fx-flex-grow" cdk-scrollable>
    <div class="sidebar-picture-container fx-layout-col fx-justify-center fx-align-center">
      <img id="sidebar-picture"
           [src]="images[0]?.url || appConfig.PLACEHOLDER_CAROUSEL"
           [alt]="images[0] && (images[0].alt || 'LABEL.ALT_WORK_MAIN_PICTURE') || 'LABEL.NO_WORK_PICTURE' | translate"/>
    </div>

    <div class="page-sidebar">
      <div class="form-container">
        @if (work) {
          <form-builder
            [formId]="formId"
            [displayHeader]="false"
            [eventsOrigin]="eventsOrigin"
            [permissionsForEdition]="permissionsForEdition">
          </form-builder>
        }
      </div>
      <div class="document-title fx-layout-row fx-justify-start fx-align-center">
        <span class="fx-flex-30-percent"> {{ 'LABEL.DOCUMENT' | translate }} </span>
        <restricted-text-button
          (click)="uploadWorkDocuments()"
          [id]="'work-upload-document-button'"
          [permissions]="[Permission.EDIT_WORK, Permission.CREATE_DOCUMENT]"
          class="btn-upload-document">
          {{ 'BUTTON.ADD_DOCUMENT' | translate }}
        </restricted-text-button>
      </div>
      @for (document of work?.documents; track document.id) {
        <div class="document-content">
          @if (accessManager.hasAccess(Permission.EXPORT_DOCUMENT)) {
            <a (click)="downloadWorkDocument(document.id)">
              <mat-icon fontSet="mdi" fontIcon="mdi-file-outline" class="xs" aria-hidden="true"></mat-icon>
              <span class="file-name-label">{{ document.name }}</span>
            </a>
          } @else {
            <span class="file-name-label">{{ document.name }}</span>
          }
          <span (click)="deleteWorkDocument(document)"
                [permission-lock]="[Permission.EDIT_WORK, Permission.DELETE_DOCUMENT]" class="delete-document-icon">
            <mat-icon fontSet="mdi" fontIcon="mdi-delete" class="xs" aria-hidden="true"></mat-icon>
          </span>
        </div>
      }
    </div>
  </div>
</div>
